import React from 'react';
import { useTranslation } from 'react-i18next';

import DecimalInput from 'commons/DecimalInput';
import Text from 'commons/Text';
import { TESTID } from 'configs/Constant';

import useStyles from './styles';

const ArtistEditionUIView = ({ totalEdition, onTotalEditionChange, isPainting, disabled }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <Text
        className={classes.label}
        mb={5}
        mt={16}
      >
        {t('edition_volume')}
        <span className={classes.require}>*</span>
      </Text>

      <DecimalInput
        value={totalEdition}
        onChange={onTotalEditionChange}
        decimalInputStyle={classes.decimalInputStyle}
        inputProps={{
          type: 'text',
        }}
        testid={TESTID.EDITION_NUMBER_ARTWORK}
        disabled={disabled || isPainting}
      />
    </>
  );
};

export default ArtistEditionUIView;
